//sticky side bar
import StickySidebar from "sticky-sidebar";

jQuery(document).ready(function ($) {
  if ($(".single-career").length) {
    let headerHeight = $("#site-header").outerHeight();
    $('a[href*="#"]')
      .not('a[href="#"]')
      .not('a[href="#0"]')
      .on("click", function (e) {
        e.preventDefault(); // prevent hard jump, the default behavior
        let target = $(this).attr("href"); // Set the target as variable
  
        // perform animated scrolling by getting top-position of target-element and set it as scroll target
        $("html, body").animate(
          {
            scrollTop: $(target).offset().top - headerHeight,
          },
          0,
          function () {
            // Initial animation complete, now add 20px more scroll
            $("html, body").animate(
              {
                scrollTop: $(target).offset().top - headerHeight - 250,
              },
              0
            ); // Adjust the duration as needed
            location.hash = target;
          }
        );
  
        return false;
      });
  }
  
  // Scroll event to add active class to active sidebar text
  $(window).on("scroll", function () {
    let headerHeight = $("#site-header").outerHeight();
    let scrollDistance = $(window).scrollTop();
  
    // Assign active class to nav links while scrolling
    if (scrollDistance >= 100) {
      $(".page-section").each(function (i) {
        let sectionTop = $(this).offset().top - headerHeight - 100;
        let sectionBottom = sectionTop + $(this).outerHeight();
  
  
        if (scrollDistance >= sectionTop && scrollDistance <= sectionBottom) {
          $("#sticky-sidebar ul li a").removeClass("active");
          $("#sticky-sidebar ul li a").eq(i).addClass("active");
        }
      });
    }
  });
  
  
});